export const skills = {
  frontend: [
    "React.js",
    "Next.js",
    "TypeScript",
    "JavaScript",
    "Material UI",
    "HTML5",
    "CSS3"
  ],
  mobile: [
    "Flutter",
    "React Native",
    "Dart",
    "Mobile App Development"
  ],
  backend: [
    "Golang",
    "JavaScript",
    "TypeScript",
    "Ruby on Rails",
    "Node.js",
    "API Developer",
    "System Design"
  ],
  cloud: [
    "AWS Cloud Developer",
    "Docker",
    "Kubernetes",
    "Linux"
  ],
  database: [
    "PostgreSQL",
    "MongoDB",
    "MySQL"
  ],
  tools: [
    "Jira",
    "Zenhub",
    "Git/GitHub",
    "Docker",
    "Kubernetes",
    "Linux"
  ]
};

export const experience = {
  company: "Dharbish Technologies",
  position: "Full Stack Developer",
  duration: "Sep 2022 - Present",
  description: "Web and Mobile Application Developer with over 3 years of experience specializing in React.js, React Next, and Node.js. Proficient in UI design, API integration, and coordinating frontend-backend systems."
};

export const education = [
  {
    degree: "B.E (Electronics & Telecommunication)",
    institution: "Dr. DY Patil School of Engineering and Technology",
    university: "Savitribai Phule Pune University, Pune",
    duration: "Aug 2017 - Aug 2022"
  },
  {
    degree: "12th HSC Board - Computer Science",
    institution: "Maharashtra Udayagiri Mahavidyalaya, Udgir",
    duration: "June 2015 - May 2017"
  },
  {
    degree: "MERN Stack Development",
    institution: "Professional Certification",
    duration: "2022"
  }
];

export const personalInfo = {
  name: "ABRAR SHAIKH",
  title: "Full Stack Developer | React.js | Node.js | Ruby on Rails",
  email: "abrardev@abrarshaikh.com", // Use professional domain
  phone: "Available on request", // Don't expose phone publicly
  summary: "Web and Mobile Application Developer with over 3 years of experience specializing in React.js, Node.js, and Ruby on Rails. Experienced in building, testing, and deploying application features using modern JavaScript, TypeScript, and popular frameworks. Proficient in collaborating within agile teams, managing sprints using Jira and Zenhub, and utilizing version control through GitHub.",
  languages: ["English", "Marathi", "Hindi"],
  certifications: ["MERN Stack Development"],
  socialWork: "Career Guidance Council (CGC) - A non-governmental organization focused on helping individuals make career decisions and providing educational support.",
  technicalSkills: ["Project Management", "UI (User Interface)", "UX (User Experience)"]
};